import { baseStore } from '@ambita/ambita-components-core';
import * as brokerLetterReportConstants from '../constants/brokerLetterReport';

const { actions: brokerLetterReportActions, events: brokerLetterReportEvents } = brokerLetterReportConstants;

export interface BrokerLetterReportState {
  data: any;
  error: any;
}

export interface BrokerLetterReportAction extends baseStore.StoreAction {
  data?: any;
  error?: any;
}

const stateReducer = (state: BrokerLetterReportState, action: BrokerLetterReportAction): BrokerLetterReportState => {
  switch (action.actionType) {
    case brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_LOADING:
      return initialState;
    case brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_LOADED:
      return {
        ...state,
        data: action.data,
        error: null
      };
    case brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_FAILED:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return state;
  }
};

const eventCollector = (_: BrokerLetterReportState, action: BrokerLetterReportAction): baseStore.StoreEvent => {
  switch (action.actionType) {
    case brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_LOADING:
      return {
        name: brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADING
      };
    case brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_LOADED:
      return {
        name: brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADED
      };
    case brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_FAILED:
      return {
        name: brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_FAILED
      };
    default:
      return null;
  }
};

const initialState: BrokerLetterReportState = {
  data: null,
  error: null
};

class BrokerLetterReport extends baseStore.Store<BrokerLetterReportState> {
  getReportData(): any {
    return this.getState().data;
  }
}

export default new BrokerLetterReport(stateReducer, eventCollector, initialState);
